import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./BbsDetail.css";
import "./swalStyle.css";
import * as BBSFunctions from "../../../../functions/Functions";
import Swal from "sweetalert2";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import * as detailsDateFormat from "../../../../components/Util/DateFormat";
import Comments from "../../../../components/Comments/Comment";
import CommentForm from "../../../../components/Comments/CommentForm";
import CommentList from "../../../../components/Comments/CommentList";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import Editor from "../../../../components/Dashboard/Editor";

function BbsDetail({ whenMovingNoticeDetail, isCommunity, fromMokLok }) {
  const initialBBSDetailData = {
    id: "",
    title: "",
    contents: "",
    regUserId: "",
    regUser: "",
    likesCount: 0,
    viewsCount: 0,
    attachments: [],
    links: {},
    regDate: "",
  };

  const navigate = useNavigate();
  const userid = localStorage.getItem("userid");
  const [bbsDetailData, setBBSDetailData] = useState({ ...initialBBSDetailData }); //게시글-조회, 수정
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isEditor, setIsEditor] = useState(false);
  const [isUsersBbs, setIsUsersBbs] = useState(false);
  const [buttonText, setButtonText] = useState("수정");
  const [commentState, setCommentState] = useState({ list: [] });
  const [likesCountState, setLikesCountState] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [deleteFileId, setDeleteFileId] = useState(null);
  const [originalData, setOriginalData] = useState({ ...initialBBSDetailData });

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/bbs/`;
  const token = localStorage.getItem("token");

  const titleChange = (e) => {
    const { name, value } = e.target;
    setBBSDetailData({
      ...bbsDetailData,
      [name]: value,
    });
  };

  const fileChange = (e) => {
    const file = e.target.files[0];
    setFileToUpload(file);
  };

  // 에디터 ref 선언
  const editorRef = useRef(null);

  //게시글 조회
  const getNoticeDetails = async () => {
    try {
      const resData = await BBSFunctions.getCommunityNoticeDetail(API_SERVER_URL, token, bbsDetailData, userid);
      if (resData.regUserId && resData.regUserId === userid) {
        setIsUsersBbs(true);
      }

      let commentList = [];
      resData.commentDTOs.map((item) => {
        let obj = { userName: item.regUser, userid: item.regUserId, comments: item.comments, regDate: detailsDateFormat.formatDateWbar(item.regDate), links: item.links };
        commentList.push(obj);
      });
      commentsUpdateList(commentList);

      setBBSDetailData({
        ...bbsDetailData,
        id: resData.id,
        title: resData.title,
        contents: resData.contents,
        regUserId: resData.regUserId,
        regUser: resData.regUser,
        likesCount: resData.likesCount,
        attachments: resData.attachments,
        links: resData.links,
        regDate: resData.regDate,
        viewsCount: resData.viewsCount,
      });
      setFileToUpload(resData.attachments.length > 0 ? resData.attachments[0] : null);

      setOriginalData({
        ...originalData,
        id: resData.id,
        title: resData.title,
        contents: resData.contents,
        regUserId: resData.regUserId,
        regUser: resData.regUser,
        likesCount: resData.likesCount,
        attachments: resData.attachments,
        links: resData.links,
        regDate: resData.regDate,
        viewsCount: resData.viewsCount,
      });

      setLikesCountState(resData.liked);
    } catch (error) {
      console.error("게시글 조회 에러:", error);
    }
  };

  useEffect(() => {
    if (whenMovingNoticeDetail) {
      bbsDetailData.id = whenMovingNoticeDetail;
      getNoticeDetails();
    }
  }, [whenMovingNoticeDetail]);

  const movingNoticePage = () => {
    const setTabFlag = fromMokLok === "상세(Community)" ? "커뮤니티" : "공지";
    navigate("/", { state: { setActiveMenu: "게시판", tabFlag: setTabFlag } });
  };

  // 게시글 수정버튼
  const modifyNotice = async () => {
    let updatedContents = "";

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updatedContents = html;
    }

    if (buttonText === "저장") {
      if (bbsDetailData.title === "") {
        swalWarningFunction("제목을 입력하세요.");
        return;
      }
      if (updatedContents === "" || updatedContents === "<p><br></p>") {
        swalWarningFunction("게시글 내용을 작성해주세요.");
        return;
      }

      const confirmationResult = await Swal.fire({
        icon: "question",
        title: "게시글 수정",
        text: "게시글을 수정하시겠습니까?",
        showCancelButton: true,
        confirmButtonText: "확인",
        cancelButtonText: "취소",
        customClass: {
          popup: "custom-swal-popup",
        },
      });

      if (confirmationResult.isConfirmed) {
        try {
          const formData = new FormData();
          formData.append("title", bbsDetailData.title);
          formData.append("contents", updatedContents);

          if (fileToUpload && fileToUpload instanceof File) {
            formData.append("newFiles", fileToUpload);
          }
          if (deleteFileId) {
            let deleteFileIds = [];
            deleteFileIds.push(deleteFileId);
            formData.append("deleteAttachmentIds", deleteFileIds);
          }

          const response = await axios.put(`${API_SERVER_URL}` + bbsDetailData.id + `/update/${userid}`, formData, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
          });

          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "성공",
              text: "게시글이 수정되었습니다.",
              customClass: {
                popup: "custom-swal-popup",
              },
            }).then(() => {
              setIsReadOnly(true);
              setButtonText("수정");
              setBBSDetailData({ ...initialBBSDetailData });
              getNoticeDetails();
              setIsEditor(!isReadOnly ? false : true);
              setIsReadOnly(!isReadOnly);
              setButtonText(!isReadOnly ? "수정" : "저장");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "실패",
              text: "게시글 수정 실패. 다시 시도해주세요.",
              customClass: {
                popup: "custom-swal-popup",
              },
            }).then(() => {
              setIsReadOnly(false);
              setButtonText("저장");
            });
          }
        } catch (error) {
          console.error("Error updating bbs:", error);

          if (error.response) {
            const responseData = error.response.data;

            if (responseData) {
              Swal.fire({
                icon: "error",
                title: "게시글 등록 오류",
                text: responseData,
                customClass: {
                  popup: "custom-swal-popup",
                },
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "서버 응답 오류",
                text: `서버 응답 오류: ${error.response.status}`,
                customClass: {
                  popup: "custom-swal-popup",
                },
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답이 없습니다.",
              text: "서버 응답이 없습니다.",
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        }
      }
    } else if (buttonText === "수정") {
      setIsEditor(!isReadOnly ? false : true);
      setIsReadOnly(!isReadOnly);
      setButtonText(!isReadOnly ? "수정" : "저장");
    }
  };

  //게시글 삭제
  const deleteNotice = async () => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "게시글 삭제",
      text: "게시글을 삭제하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        const response = await axios.delete(`/api/v1/bbs/${originalData.id}/delete`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 204) {
          const successResult = await Swal.fire({
            icon: "success",
            title: "성공",
            text: "게시글이 삭제되었습니다.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });

          if (successResult.isConfirmed) {
            setBBSDetailData({ ...initialBBSDetailData });
            movingNoticePage();
          }
        } else {
          await Swal.fire({
            icon: "error",
            title: "실패",
            text: "삭제 실패. 다시 시도해주세요.",
            confirmButtonText: "확인",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } catch (error) {
        console.error("Error deleting user:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "게시글 삭제 오류",
              text: responseData,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: "custom-swal-popup",
              },
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    }
  };

  /* 댓글 기능 */
  const { list } = commentState;

  /* 댓글 조회 */
  const getCommentList = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}${whenMovingNoticeDetail}/comment/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        let commentList = [];
        response.data.map((item) => {
          let obj = { userName: item.regUser, userid: item.regUserId, comments: item.comments, regDate: detailsDateFormat.formatDateWbar(item.regDate), links: item.links };
          commentList.push(obj);
        });
        commentsUpdateList(commentList);
      }
    } catch (error) {
      console.error("Error listing comments:", error);
    }
  };

  // 댓글 등록
  const commentsAddList = async (content) => {
    try {
      const response = await axios.post(
        `${API_SERVER_URL}` + whenMovingNoticeDetail + `/comment/create/${userid}`,
        {
          comments: content,
          parentId: 0,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 201) {
        getCommentList();
        //getNoticeDetails();
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "댓글 등록 실패. 다시 시도해주세요.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    } catch (error) {
      console.error("Error creating comments: ", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "댓글 등록 오류",
            text: responseData,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
      }
    }
  };

  const commentsUpdateList = (updatedList) => {
    setCommentState((prevState) => ({
      ...prevState,
      list: updatedList,
    }));
  };

  // 좋아요 증가
  // 좋아요(추천) 증가 또는 취소
  const recommendNotice = async () => {
    try {
      if (!likesCountState) {
        const response = await axios.put(
          `${API_SERVER_URL}${whenMovingNoticeDetail}/like/${userid}`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.status === 204) {
          bbsDetailData.likesCount = bbsDetailData.likesCount + 1;
          setLikesCountState(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "추천 실패. 다시 시도해주세요.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      } else {
        // 좋아요(추천) 취소
        const response = await axios.put(
          `${API_SERVER_URL}${whenMovingNoticeDetail}/unlike/${userid}`,
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.status === 204) {
          bbsDetailData.likesCount = bbsDetailData.likesCount - 1;
          setLikesCountState(false);
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "추천 취소 실패. 다시 시도해주세요.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error recommending notice:", error);
    }
  };

  //sweetalert warning 함수
  const swalWarningFunction = (text) => {
    Swal.fire({
      icon: "warning",
      title: "알림",
      text: text,
      customClass: {
        popup: "custom-swal-popup",
      },
    });
  };

  // undefined 회피
  let fileName = "";
  if (bbsDetailData.attachments !== undefined && bbsDetailData.attachments.length !== 0) {
    fileName = bbsDetailData.attachments[0].filename;
  }

  const fileDownload = () => {
    BBSFunctions.fileDownload(bbsDetailData.attachments[0], token);
  };

  const deleteFileClick = () => {
    if (bbsDetailData.attachments.length > 0) {
      setDeleteFileId(bbsDetailData.attachments[0].id);
    }
    setFileToUpload(null);
    setBBSDetailData((prevData) => ({
      ...prevData,
      attachments: [],
    }));
  };

  const cancelForm = () => {
    Swal.fire({
      icon: "question",
      title: "게시글 수정 취소",
      text: "수정된 내용을 저장하지 않고 취소하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      customClass: {
        popup: "custom-swal-popup",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setBBSDetailData({ ...originalData });
        setIsEditor(false);
        setIsReadOnly(true);
        setButtonText("수정");
      }
    });
  };

  return (
    <div className="bbs-detail-content-container">
      <div className={isEditor ? "bbs-detail-content-option-container" : "bbs-detail-content-option-container-nEditor"}>
        {isEditor ? <input type="text" id="noticeTitleId" name="title" value={bbsDetailData.title} placeholder="제목을 입력해 주세요." onChange={titleChange} /> : `${bbsDetailData.title}`}
      </div>
      {isEditor ? (
        <div className="bbs-detail-content-option-container-fileInput">
          <label>첨부파일: </label>

          {fileToUpload && (fileToUpload.filename || fileToUpload.name) && (
            <div className={!(fileToUpload.filename || fileToUpload.name) ? "bbs-file-name-hidden" : "bbs-file-name"}>
              {(() => {
                const fileName = fileToUpload.filename || fileToUpload.name;
                return fileName.length > 37 ? fileName.substring(0, 37) + "..." + fileName.match(/\.[^.]+$/)[0].slice(1) : fileName;
              })()}{" "}
              <span className="bbs-delete-file" onClick={deleteFileClick}>
                X
              </span>
            </div>
          )}
          {!fileToUpload && <input type="file" id="noticeDetailFileInputId" name="noticeDetailFileInput" style={{ border: "0px" }} onChange={fileChange} />}
        </div>
      ) : (
        <div className="bbs-detail-content-option-container-regInfo">
          <div className="bbs-detail-regInfo" style={{ display: "flex", flexDirection: "row" }}>
            <span className="text-align-left">
              <span className="span-text-style">조회수&nbsp;</span>
              <span>{bbsDetailData.viewsCount}</span>
            </span>
            <span className="text-align-left">
              <span className="span-text-style">작성일&nbsp;</span>
              <span>{bbsDetailData.regDate}</span>
            </span>
            <span className="text-align-left">
              <span className="span-text-style">작성자&nbsp;</span>
              <span>{bbsDetailData.regUser || "임시"}</span>
            </span>
          </div>
        </div>
      )}
      {isEditor ? (
        <div className="content-detail-quill-container">
          <Editor ref={editorRef} readOnly={false} initialHTML={bbsDetailData.contents} />
        </div>
      ) : (
        <div className="bbs-detail-contents" dangerouslySetInnerHTML={{ __html: bbsDetailData.contents }}></div>
      )}
      {!isEditor && (
        <div className="bbs-detail-fileInput-container">
          <div className="fileInput-title">첨부파일</div>
          <span className="fileInput-info">
            <a className="bbs-file-link" onClick={fileDownload}>
              {fileName.length > 37 ? fileName.substring(0, 37) + "..." + fileName.match(/\.[^.]+$/)[0].slice(1) : fileName}
            </a>
          </span>
        </div>
      )}
      <div className="parent-button-container" style={{ display: "flex", flexDirection: "row" }}>
        <div className="recommend-button-container">
          <button className={likesCountState ? "recommend-button-clicked" : "recommend-button"} onClick={recommendNotice}>
            <FontAwesomeIcon icon={faThumbsUp} />
            &nbsp;&nbsp;<span>{bbsDetailData.likesCount}</span>
          </button>
        </div>
        <div className="notice-detail-button-container">
          {isCommunity && isUsersBbs && (
            <>
              <button className="warning-button" onClick={modifyNotice}>
                {buttonText}
              </button>
              {buttonText === "수정" && (
                <button className="red-button" onClick={deleteNotice}>
                  삭제
                </button>
              )}
              {buttonText === "저장" && <button onClick={cancelForm}>취소</button>}
            </>
          )}
          <button onClick={movingNoticePage}>목록</button>
        </div>
      </div>
      <div className="comment-box-container" style={{ display: "flex", flexDirection: "column" }}>
        <div className="comments-box">
          <Comments>
            <CommentForm onSubmit={(content) => commentsAddList(content)} />
            <CommentList list={list} updatedList={commentsUpdateList} userid={userid} whenMovingNoticeDetail={whenMovingNoticeDetail} />
          </Comments>
        </div>
      </div>
    </div>
  );
}

export default BbsDetail;
